import { Injectable } from '@angular/core';
import { showSpinner, hideSpinner } from '@syncfusion/ej2-popups';

@Injectable({
  providedIn: 'root'
})
export class ProgressService {

  constructor() { }

  show() {
    showSpinner(document.getElementById('wrapper')) ;
  }

  hide() {
    hideSpinner(document.getElementById('wrapper'));
  }
}
